export default {
  'dashboard.title': 'Dashboard',
  'dashboard.widget.monthly-requests.title': 'Solicitudes del mes',
  'dashboard.widget.most-used-processes.title': 'Procesos más usados',
  'dashboard.widget.board.title': 'Cuadro de gestión',
  'dashboard.widget.board.requests': 'Solicitudes: {value}',
  'dashboard.widget.board.enabled-processes': 'Procesos habilitados: {value}',
  'dashboard.widget.board.active-users': 'Usuarios activos: {value}',
  'dashboard.widget.board.total': 'Total: {value}',
  'dashboard.widget.board.planTotal': 'Total del plan: {value}',
  'dashboard.widget.storage.title': 'Consumos',
  'dashboard.widget.storage.used-space': 'Almacenamiento / Espacio usado',
  'dashboard.widget.storage.emails-sent': 'Correos Enviados',
  'dashboard.widget.storage.entities': 'Entidades',
  'dashboard.widget.storage.generated-documents': 'Documentos Generados',
  'dashboard.widget.total-monthly-requests.title': 'Total de solicitudes por mes',
  'dashboard.widget.pending-tasks.title': 'Tareas pendientes',
  'dashboard.widget.partners.title': 'Principales colaboradores',
  'dashboard.widget.last-requests.title': 'Últimas solicitudes enviadas',
  'dashboard.widget.tasks.pending': 'Pendientes',
  'dashboard.widget.tasks.approved': 'Aprobadas',
  'dashboard.widget.tasks.rejected': 'Rechazadas',
  'dashboard.widget.tasks.canceled': 'Canceladas',
  'dashboard.widget.partners.requests': '{requests} solicitudes',
  'dashboard.widget.ai-consumptions.title': 'Consumos de IA',
  'dashboard.widget.ai-consumptions.provider': 'Proveedor',
  'dashboard.widget.ai-consumptions.model': 'Modelo',
  'dashboard.widget.ai-consumptions.family': 'Familia',
  'dashboard.widget.ai-consumptions.input-tokens': 'Tokens de Entrada',
  'dashboard.widget.ai-consumptions.output-tokens': 'Tokens de Salida',
  'dashboard.widget.ai-consumptions.cached-tokens': 'Cache Tokens',
  'dashboard.widget.ai-consumptions.total-tokens': 'Tokens Totales',
  'dashboard.widget.ai-consumptions.total-consumption': 'Consumo Total',
  'dashboard.widget.ai-consumptions.price': 'Precio',
  'dashboard.widget.ai-consumptions.no-data': 'No hay consumos de IA para mostrar',
};
